<div class="sharing-panel-container">
  <div class="w-100">
    @if (module === ExplainModuleEnum.TERRITORY_INTEL) {
      <div class="sub-title">
        {{ 'share.addressee' | translate | uppercase }}
      </div>
    }
    @if (module === ExplainModuleEnum.TENDERS) {
      <div class="pdt-6px tenders-subtitle">
        {{ 'share.addressee-tenders' | translate | uppercase }}
      </div>
    }
    <div class="input-container" appClickOutside (clickOutside)="clickOutside()" (click)="toggleDropdown(true, true, $event)">
      <div class="input input-no-focus" data-cy="share-panel-input-user" [ngClass]="{ 'input-focus': inputFocus }">
        <ng-container *ngIf="inputFocus" (click)="toggleDropdown()">
          <span
            [ngClass]="{
              'user-infos': index !== indexAddressToEdit,
              'user-selected-no-focus': index === indexAddressToEdit,
            }"
            (click)="changeEditMode(user, index, $event)"
            *ngFor="let user of selectedUsers; let index = index"
          >
            <ng-container *ngIf="index !== indexAddressToEdit">
              <span class="user-selected-focus">{{ user.email }}</span>
              <span class="user-remove" (click)="removeRecipient(user.email, $event)">
                <img class="remove-plus-icon" src="assets/images/icon-close.svg" alt="icon-close" />
              </span>
            </ng-container>
            <ng-container *ngIf="index === indexAddressToEdit">
              <span appClickOutside (clickOutside)="searchUser()">
                <input
                  #edit
                  autofocus
                  appOutlineNone
                  type="text"
                  value="{{ user.email }}"
                  (input)="onChange(true)"
                  (keyup.space)="searchUser($event)"
                  (keyup.enter)="searchUser($event)"
                  class="addressee-input edit-user"
                  data-cy="sharing-panel-addressee-input-edit-selector"
                  [size]="edit.value.length + 1"
                />
              </span>
            </ng-container>
          </span>
        </ng-container>
        <ng-container *ngIf="!inputFocus" (click)="toggleDropdown()">
          <span *ngIf="selectedUsers.length > 0" class="user-selected-no-focus">{{ selectedUsers[0].email }}</span>
          <ex-badge
            *ngIf="selectedUsers.length >= 2"
            class="ps-2"
            [text]="'+' + (selectedUsers.length - 1)"
            [backgroundColor]="'var(--basic-250)'"
            [ngbTooltip]="tooltipMoreEmails"
            tooltipClass="custom-tooltip-emails-list"
            placement="right"
            container="body"
          >
          </ex-badge>
        </ng-container>
        <input
          #autoInput
          appOutlineNone
          autocomplete="new-password"
          name="foo123"
          type="text"
          (keydown)="onKeyDown($event)"
          (input)="onChange(false)"
          (click)="toggleDropdown(true)"
          (keyup.enter)="searchUser($event)"
          (keyup.space)="searchUser($event)"
          (keyup.arrowDown)="move('down')"
          (keyup.arrowUp)="move('up')"
          (blur)="$event.preventDefault(); $event.stopPropagation()"
          [placeholder]="!selectedUsers.length ? ('share.addressee-example' | translate) : ''"
          class="addressee-input"
          data-cy="sharing-panel-addressee-input-auto-input-selector"
        />
      </div>
      <table
        aria-roledescription="list of possible addressee"
        *ngIf="addresseeDropdownMenuDisplayed"
        class="user-table"
        data-cy="share-panel-user-table-row"
        class="{{ inputSize }}"
      >
        <tbody #users id="users" data-cy="tbody-users" class="px-2 py-2">
          <div
            (click)="searchUser()"
            class="new-dest"
            [ngClass]="{
              active: indexSelected === -1,
              'new-addressee-disabled': indexSelected >= 0,
            }"
          >
            <div class="new-addressee-label">
              <span>{{ 'share.new-addressee' | translate | uppercase }}</span>
            </div>
            <div class="new-addressee-value-credits py-2">
              <div class="new-addressee">
                <div data-cy="sharing-panel-new-addressee-value" class="new-addressee-value">
                  <span class="user-main-infos">{{ inputText }}</span>
                  <span class="new-addressee-placeholder" *ngIf="!inputText">{{ 'share.addressee-example' | translate }}</span>
                  <span class="new-addressee-placeholder" *ngIf="inputText && !checkAddressContainsAtSymbol(inputText)">{{
                    'share.addressee-example-after-at-symbol' | translate
                  }}</span>
                </div>
              </div>
              <div *ngIf="errors.email" class="d-inline-flex align-items-center invalid-email">
                <span>{{ 'share.invalid-email' | translate }}</span>
              </div>
              <div *ngIf="errors.duplicatedEmail" class="d-inline-flex align-items-center invalid-email">
                <span>{{ 'share.existing-email' | translate }}</span>
              </div>
              <div class="add-remove-column new-addressee-value">
                <span></span>
                <span
                  *ngIf="newUser"
                  class="add-user"
                  [ngClass]="{ 'add-user-disabled': errors.email }"
                  (click)="onSelectAddressee(newUser, $event)"
                >
                  <ex-button type="primary" variant="raised" size="small" icon="plus"> </ex-button>
                </span>
                <span *ngIf="errors.email || errors.duplicatedEmail" class="error">
                  <i class="ph ph-warning color-primary-500 font-12px"></i>
                </span>
              </div>
            </div>
          </div>
          <!-- Recent recipients -->
          <div>
            <tr *ngIf="recentRecipients.length && !inputText" class="contact-list py-1" data-cy="share-panel-recent-contact-list">
              <td>
                <span class="contact-list-label">
                  {{ 'share.recent-recipients' | translate | uppercase }}
                </span>
              </td>
            </tr>
          </div>
          <div *ngIf="recentRecipients.length && !inputText">
            <tr
              id="{{ user.email }}"
              class="user-table-row option-item w-100 px-2 py-1"
              *ngFor="let user of recentRecipients; let index = index"
              (click)="onSelectAddressee(user, $event)"
              [ngClass]="{ disabled: checkIfUserSelected(user.email) }"
            >
              <div
                [ngClass]="{
                  'user-main': true,
                  'user-selected': checkIfUserSelected(user.email),
                }"
                appShowIfTruncated
                [ngbTooltip]="tooltipEmailCaller"
                tooltipClass="share-tooltip-default tooltip-max-300"
                [disableTooltip]="true"
                placement="bottom"
                container="body"
              >
                <ng-template #tooltipEmailCaller>
                  <ng-container *ngTemplateOutlet="tooltipEmail; context: { $implicit: user.email }"></ng-container>
                </ng-template>
                <ng-container *ngIf="isSimpleUser(user) && isInSameCompany(user); else noNameInTable">
                  <span
                    class="user-main-infos"
                    [innerHTML]="user.fullName && (user.fullName | titlecase | highlight: autoInput.value) + '&nbsp'"
                  ></span>
                  <span class="user-details" [innerHTML]="'(' + (user.email | highlight: autoInput.value) + ')'"></span>
                </ng-container>
                <ng-template #noNameInTable>
                  <span
                    [innerHTML]="user.email | highlight: autoInput.value"
                    [ngClass]="{
                      'user-main-infos': true,
                    }"
                  >
                  </span>
                </ng-template>
              </div>
              <div class="add-remove-column">
                <span
                  *ngIf="!checkIfUserSelected(user.email)"
                  class="add-user add-user-hover hidden"
                  (click)="onSelectAddressee(user, $event)"
                >
                  <ex-button type="primary" variant="raised" size="small" icon="plus"> </ex-button>
                </span>
                <span *ngIf="checkIfUserSelected(user.email)" class="remove-user" (click)="removeRecipient(user.email, $event)">
                  <ex-button type="danger" variant="tonal" size="small" icon="x"> </ex-button>
                </span>
              </div>
            </tr>
          </div>
          <!-- Recipients list -->
          <div>
            <tr
              *ngIf="!autoInput.value"
              (click)="displayOrHideContactList($event)"
              class="contact-list cursor-pointer"
              data-cy="share-panel-contact-list"
            >
              <td>
                <span class="contact-list-label">
                  {{ (isContactListSelected ? 'share.contact-list-hide' : 'share.contact-list-display') | translate | uppercase }}
                </span>
              </td>
              <td class="contact-list-chevron">
                <mat-icon *ngIf="!isContactListSelected" svgIcon="chevron-down"></mat-icon>
                <mat-icon *ngIf="isContactListSelected" svgIcon="chevron-up"></mat-icon>
              </td>
            </tr>
          </div>
          <div *ngIf="isContactListSelected || inputText !== ''">
            <tr
              class="user-table-row option-item w-100 px-2 py-1"
              *ngFor="let user of filteredOptions$ | async; let index = index"
              (click)="onSelectAddressee(user, $event)"
              [ngClass]="{
                active: index === indexSelected,
                disabled: checkIfUserSelected(user.email),
              }"
              id="{{ user.email }}"
            >
              <div
                [ngClass]="{
                  'user-main': true,
                  'user-selected': checkIfUserSelected(user.email),
                }"
                appShowIfTruncated
                [ngbTooltip]="tooltipEmailCaller"
                tooltipClass="share-tooltip-default tooltip-max-300"
                [disableTooltip]="true"
                placement="bottom"
                container="body"
              >
                <ng-template #tooltipEmailCaller>
                  <ng-container *ngTemplateOutlet="tooltipEmail; context: { $implicit: user.email }"></ng-container>
                </ng-template>
                <ng-container *ngIf="isSimpleUser(user) && isInSameCompany(user); else noNameInTable">
                  <span
                    class="user-main-infos"
                    [innerHTML]="user.fullName && (user.fullName | titlecase | highlight: autoInput.value) + '&nbsp'"
                  ></span>
                  <span class="user-details" [innerHTML]="'(' + (user.email | highlight: autoInput.value) + ')'"></span>
                </ng-container>
                <ng-template #noNameInTable>
                  <span
                    [innerHTML]="user.email | highlight: autoInput.value"
                    [ngClass]="{
                      'user-main-infos': true,
                    }"
                  >
                  </span>
                </ng-template>
              </div>
              <div class="add-remove-column">
                <span
                  *ngIf="!checkIfUserSelected(user.email)"
                  class="add-user add-user-hover hidden"
                  (click)="onSelectAddressee(user, $event)"
                >
                  <ex-button type="primary" variant="raised" size="small" icon="plus"> </ex-button>
                </span>
                <span *ngIf="checkIfUserSelected(user.email)" class="remove-user" (click)="removeRecipient(user.email, $event)">
                  <ex-button type="danger" variant="tonal" size="small" icon="x"> </ex-button>
                </span>
              </div>
            </tr>
          </div>
        </tbody>
      </table>
    </div>
  </div>
  <div
    class="message-part w-100"
    [ngClass]="{ tenders: module === ExplainModuleEnum.TENDERS, 'territory-intel': module === ExplainModuleEnum.TERRITORY_INTEL }"
  >
    @if (!inputHtml) {
      <div class="sub-title">
        {{ 'share.message' | translate | uppercase }}
        <span class="fst-italic"> {{ 'share.optional' | translate | lowercase }}</span>
      </div>
      <div class="container-textarea">
        <textarea
          appOutlineNone
          data-cy="sharing-panel-sharing-message-input"
          class="input-share-message"
          maxlength="1000"
          [(ngModel)]="shareMessage"
        >
        </textarea>
        <span class="counter-textarea">{{ shareMessage.length }}/1000</span>
      </div>
    }
    <div class="send-copy flex-row-reverse justify-content-end">
      <span>{{ 'share.send-mail-copy' | translate }}</span>
      <label class="switch checkbox">
        <input type="checkbox" (change)="onSendCopyChange()" />
        <span class="slider round"></span>
      </label>
    </div>
  </div>
  @if (module === ExplainModuleEnum.TERRITORY_INTEL) {
    <mat-divider class="color-basic-500"></mat-divider>
    <div class="validation-part w-100 d-table">
      <div class="w-100 d-table-cell"></div>
      <div class="d-flex align-items-end gap-2">
        <ex-button type="primary" variant="ghost" (click)="reset(); cancel.emit()">
          {{ 'share.close' | translate | titlecase }}
        </ex-button>
        <ex-button
          data-cy="sharing-panel-send-button"
          type="primary"
          variant="raised"
          onclick="this.blur()"
          (click)="onSubmit()"
          [disabled]="!selectedUsers.length"
        >
          {{ 'share.send' | translate | titlecase }}
        </ex-button>
      </div>
    </div>
  }
  @if (module === ExplainModuleEnum.TENDERS) {
    <button
      class="btn share-action-btn d-flex"
      type="submit"
      onclick="this.blur()"
      (click)="onSubmit()"
      [disabled]="disableShareButton || !selectedUsers.length"
    >
      <i class="ph-fill ph-envelope-simple fs-5"></i>
      <span class="align-self-center">{{ 'share.send' | translate | titlecase }}</span>
    </button>
  }
</div>

<app-toast-message [createMessage]="'share.toast-content'"></app-toast-message>
<ng-template #tooltipMoreEmails>
  <ul class="emails-list">
    <li *ngFor="let user of selectedUsers" class="email">{{ user.email }}</li>
  </ul>
</ng-template>
<ng-template #tooltipEmail let-email>
  <span>{{ email }}</span>
</ng-template>

<ng-template #sharingToast let-toast="toast" let-toastService="toastService">
  <div class="position-relative d-flex w-100 h-100">
    <div class="position-absolute toast-icon-div icon--close align-self-center" (click)="toastService.remove(toast)"></div>
    <img src="assets/images/icon-checkmark-circle.svg" class="align-self-center toast-image" alt="icon-checkmark" />
    <div class="fw-bold align-self-center toast-text">
      <ng-container>
        <p class="m-0">{{ 'share.toast-content' | translate }}</p>
      </ng-container>
    </div>
  </div>
</ng-template>
